import { render, staticRenderFns } from "./SettingsVerifyEmail.vue?vue&type=template&id=6d1449d2&scoped=true&"
import script from "./SettingsVerifyEmail.vue?vue&type=script&lang=js&"
export * from "./SettingsVerifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./SettingsVerifyEmail.vue?vue&type=style&index=0&id=6d1449d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1449d2",
  null
  
)

export default component.exports